import React, { memo } from 'react';
import { Row, Col, Empty, Skeleton } from 'components';
import { CommercialOfferCard } from './CommercialOfferCard';
import { CommercialOfferModel } from 'models/CommercialOffer';
import styles from './styles.module.scss';

interface OfferListProps {
  offers: CommercialOfferModel[];
  isLoading: boolean;
  onDelete: (id: string) => void;
  onView: (id: string) => void;
  onAction: (action: string, id: string, uuid: string) => void;
  onCreateCopy: (id: string) => void;
}

export const OfferList: React.FC<OfferListProps> = memo(
  ({ offers, isLoading, onDelete, onView, onAction, onCreateCopy }) => {
    if (isLoading) {
      return (
        <div className={styles.loading_container}>
          <Skeleton active />
        </div>
      );
    }

    if (!offers.length) {
      return <Empty description="No commercial offers found" className={styles.empty_state} />;
    }

    return (
      <Row gutter={[0, 8]}>
        {offers.map((offer: CommercialOfferModel) => (
          <Col span={24} key={offer.id}>
            <CommercialOfferCard
              commercialOffer={offer}
              onDelete={onDelete}
              onView={onView}
              onAction={onAction}
              onCreateCopy={onCreateCopy}
            />
          </Col>
        ))}
      </Row>
    );
  }
);
